// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"tW","tooltipWrapper":"uW","icon":"vW","tooltip":"wW","content":"xW"};